// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductsList_root__3yUXp","one":"ProductsList_one__1tP6K","two":"ProductsList_two__20WOE"};